/* https://www.npmjs.com/package/react-spinners */

import React, { Component } from 'react';

import Options from "./Options";
import SelectedOptions from "./SelectedOptions";

import ClipLoader from "react-spinners/ClipLoader";

export default class FeatureItem extends Component {

    constructor(props) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
        this.contentEl = React.createRef();
    }

    state = { isActive: false, isUpdating: false };

    handleToggle = () => {

        this.setState({ isActive: !this.state.isActive });
    };
    statusUpdating = (status) => {

        this.setState({ isUpdating: status });
    };

    render() {

        const feature = this.props.feature;
        const isActive = this.state.isActive;
        const isUpdating = this.state.isUpdating;
        const debug = this.props.debug;
        const extDisable = this.props.extDisable;

        const colorLoader = "white";
        const colorStatusClass = //isUpdating ? "blueOptFea":
            feature.options.filter((f) => f.selected).length > 0
                ? "grnOptFea"
                : feature.options.filter((f) => f.active).length > 0 ? (feature.required || (!feature.required && feature.requiredRule) || (feature.options.filter((f) => f.required).length > 0) ? "redOptFea" : "yellowOptFea") : "greyOptFea";

        return (
            <tr className={`featureItem ${isActive ? "active" : ""}`}>
                <td>
                    <button className="featureItemHeader" onClick={this.handleToggle}>
                        <table>
                            <tbody>
                                <tr className="selOptFea">
                                    <td
                                        className={`${colorStatusClass}`}
                                    >
                                        <div id={`${colorStatusClass}`} style={isUpdating == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={isUpdating}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>

                                    <td className="featureItemHeaderCaption">
                                        {feature.name} {debug ? "| required=" + String(feature.required) + " requiredRule=" + String(feature.requiredRule) + " | " + isUpdating + " | " + feature.options.filter((f) => f.selected).length: ""}
                                        <SelectedOptions options={feature.options.filter((f) => f.selected)} />
                                    </td>
                                    <td className="selOptFeaPlusMinus">
                                        <div>
                                            <span>{isActive ? "-" : "+"} </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </button>
                    <div style={isActive ? { display: "block" } : { display: "none" }}>
                        <Options extDisable={this.props.extDisable} configurationId={this.props.configurationId}
                            options={feature.options}
                            debug={debug}
                            requiredFeature={feature.required}
                            updateConfiguration={this.props.updateConfiguration}
                            handleToggle={this.handleToggle}
                            updatePostingStatus={this.statusUpdating}
                            handleLock={this.props.handleLock}
                            showError={this.props.showError}
                        />
                    </div>
                </td>
            </tr>
        );
    }
}
